/* global Blob, OffscreenCanvas, Image */
import Store from 'store/store'
import APIServer from 'controllers/api-server'
import Convert from 'utils/convert'
import * as DomCMYK from 'utils/dom-cmyk-color'

const SVG_CALLBACKS = {
  imagesToDataURL: async svg => {
    const images = svg.querySelectorAll('image[href]')
    for (const image of images) {
      const src = image.getAttribute('href')
      const dataURL = await Convert.objectURL(src).toDataURL()
      image.setAttribute('href', dataURL)
    }
  },

  imagesToFilenames: svg => {
    const images = svg.querySelectorAll('image[href][data-filename]')
    for (const image of images) {
      image.setAttribute('href', image.getAttribute('data-filename'))
    }
  },

  storeImageBlobs: files => async svg => {
    const images = svg.querySelectorAll('image[href][data-filename]')
    for (const image of images) {
      const href = image.getAttribute('href')
      const filename = image.getAttribute('data-filename')
      files[filename] = await Convert.objectURL(href).toBlob()
    }
  }
}

export default {
  png: paper => new Promise(resolve => {
    window.requestIdleCallback(async () => {
      const svgString = await paper.toSVGString(SVG_CALLBACKS.imagesToDataURL)
      const svgBlob = new Blob([svgString], { type: 'image/svg+xml' })

      const image = new Image()
      image.onload = async function () {
        const canvas = window.OffscreenCanvas
          ? new OffscreenCanvas(this.width, this.height)
          : document.createElement('canvas')

        if (!window.OffscreenCanvas) {
          canvas.width = this.width
          canvas.height = this.height
        }

        const ctx = canvas.getContext('2d')
        ctx.fillStyle = 'white'
        ctx.fillRect(0, 0, this.width, this.height)
        ctx.drawImage(image, 0, 0)

        URL.revokeObjectURL(this.src)
        if (window.OffscreenCanvas) resolve({ blob: await canvas.convertToBlob() })
        else canvas.toBlob(blob => resolve({ blob }))
      }

      image.src = URL.createObjectURL(svgBlob)
    })
  }),

  svg: async paper => {
    const colorSpace = paper.state.colorSpace.get()
    const svgString = await paper.toSVGString([
      SVG_CALLBACKS.imagesToDataURL,
      colorSpace === 'cmyk' && DomCMYK.resolveCustomAttributes,
      colorSpace === 'cmyk' && DomCMYK.resolveNamedValues
    ])
    return {
      blob: new Blob([svgString], { type: 'image/svg+xml' })
    }
  },

  pdf: async paper => {
    const files = {}
    const colorSpace = paper.state.colorSpace.get()
    const isCMYK = (colorSpace === 'cmyk')

    const svgString = await paper.toSVGString([
      SVG_CALLBACKS.storeImageBlobs(files),
      SVG_CALLBACKS.imagesToFilenames,
      isCMYK && DomCMYK.resolveCustomAttributes,
      isCMYK && DomCMYK.resolveNamedValues
    ])

    const { response, location } = await APIServer.pdf({
      svgString,
      files,
      pdfOptions: {
        colorSpace,
        title: '' + Store.landscape.seed.get(),
        subject: 'FFP',
        author: window.ENV.name + '@' + window.ENV.version,
        userUnit: paper.props.format.dimensions[2],
        createFilesReport: false,
        bleed: isCMYK ? Store.constants.current.BLEED : 0,
        marks: {
          colors: isCMYK,
          crop: isCMYK,
          registration: isCMYK
        }
      }
    })

    if (!window.ENV.production) console.log(response)
    return { url: location }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/export.js